<template>
  <div>
    <Intro
      :isLoggedIn="loggedIn"
      :firstName="loggedIn ? getUserData.firstName : null"
      :video="
        loggedIn && getUserData.applicants.length
          ? getUserData.applicants[0].video
          : null
      "
    />
    <div v-if="loggedIn">
      <CandidateAdmin :key="this.$store.state.candidate.updateKey" />
    </div>

    <div v-if="!loggedIn">
      <JobDescription />
      <Process />
      <CandidateDetails />
    </div>
  </div>
</template>

<script>
//import axios from 'axios';
import { authComputed } from '@/store/helpers';

import Intro from '@/components/Homepage/1-Intro';
import JobDescription from '@/components/Homepage/2-JobDescription';
import Process from '@/components/Homepage/3-Process';
import CandidateDetails from '@/components/Homepage/4-CandidateDetails';
import CandidateAdmin from '@/components/Homepage/CandidateAdmin';

export default {
  components: {
    Intro,
    JobDescription,
    Process,
    CandidateDetails,
    CandidateAdmin,
  },
  computed: {
    ...authComputed,
    loggedInType() {
      return this.getUserData.type;
    },
  },
  methods: {},
  created() {
    //const self = this;
    // if (this.loggedInType === 'recruiter') {
    //   if (window.location.pathname === '/') {
    //     this.$router.push('/recruiter/job-posts');
    //   }
    // }
    //check video thumbnail
    // console.log(this.getUserData);
    // console.log(this.getUserData.candidate.videoThumb);
    // if (!this.getUserData.candidate.videoThumb) {
    //   console.log('no video thumb');
    //   //get video
    //   let Vimeo = require('vimeo').Vimeo;
    //   let client = new Vimeo(
    //     '757d27075fbb47670d8e45a767f6c2ce7b050279',
    //     'FAmshigr/NFiWUjSw1Hi/etD4b7Lflh318tHkR7RiTGT3rVhna7V5vkU60I/nXO+CK5fhDzdYTb/7BTyKh7VERJ6NmQX7VHfMsl1Y3DzgT2oFa5eAiEEjPHXq2L/goS4',
    //     '9ea71d9d177393d7954e1a5a725b070c'
    //   );
    //   client.request(
    //     {
    //       method: 'GET',
    //       path: `videos/${self.getUserData.candidate.video}`,
    //     },
    //     function (error, body) {
    //       if (error) {
    //         console.log(error);
    //       }
    //       console.log(body);
    //       axios.put(
    //         process.env.VUE_APP_REST_HTTP
    //           ? `${process.env.VUE_APP_REST_HTTP}/candidates/${self.getUserData.candidate.id}`
    //           : `http://localhost:1337/candidates/${self.getUserData.candidate.id}`,
    //         {
    //           videoThumb: body.pictures.sizes[1].link,
    //         }
    //       );
    //     }
    //   );
    // }
  },
};
</script>

<style lang="scss">
/*  */
</style>
